import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { Picks } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PicksService extends TmsWebBaseEditService<Picks, Picks> {
  constructor() {
    super('Picks', $localize`Pick Wheel`);
  }
}
